import { useCallback } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { useFetch } from "@/hooks/useFetch";

// Tipo de contrato por colaborador: PJ se estiver numa seção PJ da folha ou com contract_type "pj"; senão CLT.
export const useContractTypes = () => {
  const pjSettings = useFetch("/admin/payroll-settings");
  const collabs = useQuery({ queryKey: ["all-collabs-nobase"], queryFn: async () => (await api.get("/admin/collaborators", { skipBaseId: true })).data?.collaborators || [] });
  const fn = useCallback((uid) => {
    const secs = pjSettings.data?.sections || {};
    if (["ciclista_pj", "motociclista_pj"].some((s) => (secs[s]?.drivers || []).some((d) => d.id === uid))) return "pj";
    const c = (collabs.data || []).find((x) => x.id === uid);
    return String(c?.contract_type || "clt").toLowerCase() === "pj" ? "pj" : "clt";
  }, [pjSettings.data, collabs.data]);
  fn.ready = !!pjSettings.data && collabs.isSuccess;
  return fn;
};
